import React, { forwardRef, useRef } from "react";
import InputMask from "react-input-mask";
import clsx from "clsx";
import { MessageError } from "../common";

type TaxIdInputProps = Omit<React.ComponentProps<typeof InputMask>, "mask"> & {
  isInvalid?: boolean | string | null;
  isValid?: boolean | string | null;
  messageError?: string;
  showError?: boolean;
  typeMask: "cpf" | "cnpj" | "month" | "year" | "day" | "credit_card" | "ccv";
};

const TaxIdInput = forwardRef<HTMLInputElement, TaxIdInputProps>(
  ({
    isInvalid,
    isValid,
    messageError,
    showError = true,
    className,
    typeMask,
    onChange,
    value,
    ...props
  }) => {
    const inputRef = useRef<InputMask>(null);

    function getMask(mask: string) {
      switch (mask) {
        case "cpf":
          return "999.999.999-99";
        case "cnpj":
          return "99.999.999/9999-99";
        case "month":
          return "99";
        case "year":
          return "9999";
        case "day":
          return "99";
        case "credit_card":
          return "9999 9999 9999 9999";
        case "ccv":
          return "999";
        default:
          return mask;
      }
    }

    return (
      <div className="space-y-1">
        <InputMask
          ref={inputRef}
          mask={getMask(typeMask)}
          value={value}
          onChange={onChange}
          className={clsx(
            "flex h-10 w-full rounded-md border border-input bg-background px-4 py-2 text-sm placeholder:text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/35 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className,
            {
              "is-invalid": isInvalid,
            },
            {
              "is-valid": isValid,
            }
          )}
          {...props}
        />
        {showError && isInvalid && (
          <MessageError isInvalid={isInvalid} messageError={messageError} />
        )}
      </div>
    );
  }
);

TaxIdInput.displayName = "TaxIdInput";

export { TaxIdInput };
